import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";
import { EmptyRecRepFilter, Filter, IRecRepFilter } from "./Filter";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { AutoFillTimeSheet } from "./AutoFillTimeSheet";

interface ITimeSheetReport {
    login_ID?: number,
    recruiter?: string,
    branchName?: string,
    allReq?: number,
    onsite?: number,
    hybrid?: number,
    remote?: number,
    serve?: number,
    unServe?: number,
    submittal?: number,
    eci?: number,
    po?: number
}
interface IProps {
    // setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    // permissions: IPermissionProps,
    // byConsultant: number,
    po: any,
}

export const SubvendorTimeSheetReport = (props: IProps) => {
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);
    const [subVendorFilter, setSubVendorFilter] = useState<IRecRepFilter>(EmptyRecRepFilter);
    const [subVendorData, setSubVendorData] = useState({ historytableData: [], loading: false } as { historytableData: Array<any>, loading: boolean });
    const [timesheetLeft, setTimesheetLeft] = useState<number>(0);
    const [tableLoad, setTableLoad] = useState(false);

    const [autoFillTimesheet, setAutoFillTimesheet] = useState({ singleData: {}, open: false, po: {}, recent: {}, timeSheetCount: 0 } as { singleData: any, open: boolean, po: any, recent: any, timeSheetCount: number });
    const hideAutoFilltTimesheetDialog = () => { setAutoFillTimesheet({ singleData: {}, open: false, po: {}, recent: {}, timeSheetCount: 0 }); };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Pending SubVendor Timesheets Report</h5>
        </div>
    );


    const loadTableData2 = async () => {
        setSubVendorData({ historytableData: subVendorData.historytableData, loading: true });
        const response = await Fetch("Report_Timesheet/getSubvendorTimesheetLeft", "GET", null, `filter=${JSON.stringify(subVendorFilter)}`, null);
        if (response) {
            const data = await response.json();
            console.log(data.consultantNames)
            setTimesheetLeft(data.timesheetLeft);
            setSubVendorData({ historytableData: data.subVendorTimesheetsLeft, loading: false });
        } else {
            setSubVendorData({ historytableData: subVendorData.historytableData, loading: false });
        }
    }

    const sendMail = async (data: any) => {
        const response = await Fetch('Report_Timesheet/sendmailToSubvendor', 'POST', null, `sub_Vendor_Contact_Person_Email=${data.sub_Vendor_Contact_Person_Email}&Recruiter_ID=${data.recruiter_ID}`, null);
        if (response) {
            toast.current.show({ severity: 'success', detail: 'Mail sent successfully to POC.', life: 3000 });
        }
    };

    const rejectFunc = () => {
        toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 })

    }
    const confirmDelete = (rowData: any) => {
        confirmDialog({
            message: `Are you sure you want to send an email to ${rowData.sub_Vendor_Contact_Person_Email}`,
            header: 'Send Email Confirmation',
            icon: 'pi pi-envelope',
            acceptClassName: 'p-button-success',
            rejectClassName: 'p-button-secondary',
            acceptLabel: 'Yes, Send',
            rejectLabel: 'Cancel',
            accept: () => sendMail(rowData),
            reject: () => rejectFunc()
        });
    }

    const sendCompanyDetail = (rowData: any) => {
        console.log(rowData.sub_Vendor_Contact_Person_Email)
        return (
            <>
                <Button icon="pi pi-envelope" className="p-button-rounded  p-button-text ml-2" onClick={() => confirmDelete(rowData)} tooltip="Send an email to the poc" />
            </>
        )
    }

    const getPendingTimesheetLeft = (rowData: any) => {
        return (
            <div className="flex w-full">
                <div className="flex w-25rem">{timesheetLeft !== 0 && <h1 className="flex text-2xl font-bold mr-5 hover:text-blue-700 hover:underline" style={{ cursor: "pointer" }} onClick={() => {
                    setAutoFillTimesheet({ open: true, singleData: { consultant_ID: rowData.consultant_ID, pO_ID: rowData.pO_ID }, po: rowData, recent: rowData, timeSheetCount: rowData.timesheetsLeft });
                }}><span style={{ color: 'red' }}>{rowData.timesheetsLeft}</span></h1>}</div>
            </div>

        );
    };

    useEffect(() => {
        if(tableLoad){
        loadTableData2();
        setTableLoad(false);
        }
    }, [subVendorFilter]);

    return (
        <>

            <Accordion>
                <AccordionTab header="Filter">
                    <Filter salEffFilter={subVendorFilter} setSalEffFilter={setSubVendorFilter} onsearch={()=> setTableLoad(true)}/>
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                loading={subVendorData.loading}
                value={subVendorData.historytableData}
                header={header}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="subVendorNames" header="Sub Vendor" />
                <Column field="consultantName" header="Consultant" />
                <Column field="salesmanager" header="Sales Manager" />
                <Column field="sales_Company_Branch" header="Sales Comp (Branch)" sortable />
                <Column field="user_Name" header="Recruiter" />
                <Column field="recruiter_Company_Branch" header="Recruiter Comp (Branch)" sortable />
                <Column field="timesheetsLeft" header="Timesheets Left" body={getPendingTimesheetLeft} />
                <Column field="" header="Send Mail" body={sendCompanyDetail} />
            </DataTable>
            <ConfirmDialog />
            <AutoFillTimeSheet singleData={autoFillTimesheet.singleData} open={autoFillTimesheet.open} hideDialog={hideAutoFilltTimesheetDialog} toast={props.toast} setReload={props.setReload} po={props?.po} recent={autoFillTimesheet.recent} timeSheetCount={autoFillTimesheet.timeSheetCount} reloadDialog={() => {
                loadTableData2();
            }} filter={subVendorFilter} />
            <Toast ref={toast} />
        </>
    );
}
